document.addEventListener("DOMContentLoaded", () => {
	if (document.querySelector(".mdig-accordion-init")) {
		const accordions = document.querySelectorAll(".mdig-accordion-init");

		accordions.forEach((accordion) => {
			const items = accordion.querySelectorAll(".mdig-accordion-item");

			window.addEventListener("resize", () => {
				items.forEach((item) => {
					const contentExpandable = item.querySelector(
						".mdig-accordion-content-expandable",
					);
					const content = contentExpandable.querySelector(
						".mdig-accordion-content",
					);
					if (contentExpandable.style.height !== "0px") {
						contentExpandable.style.height = `${content.scrollHeight}px`;
					}
				});
			});

			items.forEach((item, index) => {
				const contentExpandable = item.querySelector(
					".mdig-accordion-content-expandable",
				);
				const content = contentExpandable.querySelector(
					".mdig-accordion-content",
				);
				const svg = item.querySelector(".mdig-accordion-icon svg");
				contentExpandable.style.overflow = "hidden";

				if (index === 0) {
					contentExpandable.style.height = `${content.scrollHeight}px`;
				} else {
					contentExpandable.style.height = `0px`;
					svg.style.transform = "rotate(180deg)";
				}
				setTimeout(() => {
					contentExpandable.style.transition = "height 0.3s ease";
					svg.style.transition = "transform 0.3s ease";
				}, 5);
			});

			items.forEach((item) => {
				const button = item.querySelector(".mdig-expand-item");
				const contentExpandable = item.querySelector(
					".mdig-accordion-content-expandable",
				);
				const content = contentExpandable.querySelector(
					".mdig-accordion-content",
				);
				const svg = item.querySelector(".mdig-accordion-icon svg");

				button.addEventListener("click", () => {
					items.forEach((otherItem) => {
						if (otherItem !== item) {
							const otherContentExpandable = otherItem.querySelector(
								".mdig-accordion-content-expandable",
							);
							const otherContent = otherContentExpandable.querySelector(
								".mdig-accordion-content",
							);
							const otherSvg = otherItem.querySelector(
								".mdig-accordion-icon svg",
							);
							otherContentExpandable.style.height = `0px`;
							otherSvg.style.transform = "rotate(180deg)";
						}
					});

					if (contentExpandable.style.height === "0px") {
						contentExpandable.style.height = `${content.scrollHeight}px`;
						svg.style.transform = "rotate(0deg)";
					} else {
						contentExpandable.style.height = `0px`;
						svg.style.transform = "rotate(180deg)";
					}
				});
			});
		});
	}
});
